export default "__VITE_ASSET__e8d49f67__"